import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { customPaymentMethods } from "@jti/fe-common";
import { deletePaymentTokenFromStorage } from "@jti/store";
import { PolicyCheckFieldsWrapper } from "../../../../components/PolicyCheckFieldsWrapper";
import { useAemModel } from "../../../../contexts/AemModelContext";
import usePgsClient from "../../../../hooks/payment/usePgsClient";
import { PaymentPagePayButtons } from "../PaymentPagePayButtons";
import { PaymentPageSecureBlock } from "../PaymentPageSecureBlock";
import { PaymentPageTotalPrice } from "../PaymentPageTotalPrice";
import styles from "./PaymentPageFooter.module.scss";
export const PaymentPageFooter = ({ paymentMethodCode, ...restProps }) => {
    const { orderId } = useParams();
    const { consentsConfig } = useAemModel();
    const [isPolicyRead, setIsPolicyRead] = useState(false);
    const payButtonContainerRef = useRef(null);
    usePgsClient({
        ref: payButtonContainerRef,
        paymentCode: paymentMethodCode,
        onUnmount: deletePaymentTokenFromStorage,
        buttonClassName: "payButton",
        orderId,
    });
    const jtiPolicyConsentCheckboxEnabled = !consentsConfig?.policyAndTermsConsentDisabled;
    const isPayOnDeliverySelected = paymentMethodCode === customPaymentMethods.payOnDelivery;
    const showPolicyCheck = isPayOnDeliverySelected || jtiPolicyConsentCheckboxEnabled;
    return (_jsxs("div", { className: styles.container, ...restProps, children: [_jsx(PaymentPageTotalPrice, {}), showPolicyCheck && (_jsx(PolicyCheckFieldsWrapper, { setIsPolicyRead: setIsPolicyRead, className: styles.policyCheckField, "data-testid": "policy-fields-wrapper" })), _jsx(PaymentPagePayButtons, { isPolicyRead: isPolicyRead, paymentMethodCode: paymentMethodCode, isPayOnDelivery: isPayOnDeliverySelected, showPolicyCheck: showPolicyCheck, ref: payButtonContainerRef }), _jsx(PaymentPageSecureBlock, {})] }));
};
//# sourceMappingURL=PaymentPageFooter.js.map